import script from "./TiptapEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./TiptapEditor.vue?vue&type=script&setup=true&lang=ts"

import "./TiptapEditor.vue?vue&type=style&index=0&id=b79a785c&lang=css"

const __exports__ = script;

export default __exports__